package com.kinoshazam.uiKit.components.button

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.theme.UiKitTheme

/**
 * Circular outlined icon button (desktop search FAB / search submit).
 * Default: [color_1] border + white icon. Hover (when enabled): fill [color_1].
 */
@Composable
fun OutlinedCircleIconButton(
    painter: Painter,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    isLoading: Boolean = false,
    size: Dp = 40.dp,
    borderWidth: Dp = 1.5.dp,
    contentDescription: String? = null,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    val active = enabled && !isLoading
    val showHoverFill = isHovered && active
    val borderColor = if (enabled) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_16
    val iconTint = if (enabled) UiKitTheme.colors.color_2 else UiKitTheme.colors.color_16

    Box(
        modifier = modifier
            .size(size)
            .clip(CircleShape)
            .then(
                if (showHoverFill) {
                    Modifier.background(UiKitTheme.colors.color_1, CircleShape)
                } else {
                    Modifier
                }
            )
            .border(borderWidth, borderColor, CircleShape)
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                enabled = active,
                onClick = onClick,
            ),
        contentAlignment = Alignment.Center,
    ) {
        if (isLoading) {
            CircularProgressIndicator(
                modifier = Modifier.size(size * 0.45f),
                color = UiKitTheme.colors.color_1,
                strokeWidth = 2.dp,
            )
        } else {
            Icon(
                painter = painter,
                contentDescription = contentDescription,
                tint = iconTint,
                modifier = Modifier.size(size * 0.45f),
            )
        }
    }
}
